import React from "react";
import { object, array, string, number } from "prop-types";
import get from "lodash/get";
import cx from "classnames";
import { connect } from "react-redux";
import "./card-image.m.css";
import LazyEagerImage from "../lazy-eager";

const CardImage = ({ story = {}, defaultImage,cdnImage, aspectRatio, defaultWidth, imageType = "image16x9", widths = [250, 480, 764] }) => {
  const wrapperStyleName = cx(
    "qt-image-dynamic",
    { image16x9: imageType === "image16x9" },
    { image4x3: imageType === "image4x3" },
    { image1x1: imageType === "image1x1" },
    { image302x403: imageType === "image302x403" },
    { image1x2: imageType === "image1x2" },
    { image9x16: imageType === "image9x16" },
    { image3x2: imageType === "image3x2" },
    { imageOriginalShape: imageType === "imageOriginalShape" }
  );
  const imgURL = story["hero-image-url"];
  const imgS3keys = story["hero-image-s3-key"];
  var widthParameter = '';


  if (story["story-template"] === "wau-juttu") {
    widthParameter = "w=2080";
  } else {
    widthParameter = "w=980"
  }

  const captionAlt= story["hero-image-caption"]?story["hero-image-caption"]:"story-image"
//find rect starts
const imgMeta = story["hero-image-metadata"];
const imgHeight = imgMeta?.height || 0.5;
const imgWidth = imgMeta?.width || 0.5;
const focus = imgMeta?.["focus-point"] || [imgWidth/2,imgHeight/2];
function imageBounds() {
  let expectedHeight, expectedWidth, bound;
  const [focusX, focusY] = focus;
  if (imgWidth * aspectRatio[1] < imgHeight * aspectRatio[0]) {
    expectedHeight = (imgWidth * aspectRatio[1]) / aspectRatio[0];
    bound = findBounds(imgHeight, expectedHeight, focusY);
    return [0, Math.round(bound), imgWidth, Math.round(expectedHeight)];
  } else {
    expectedWidth = (imgHeight * aspectRatio[0]) / aspectRatio[1];
    bound = findBounds(imgWidth, expectedWidth, focusX);
    return [Math.round(bound), 0, Math.round(expectedWidth), imgHeight];
  }
}
function findBounds(imageWidth, cropWidth, focus) {
  let leftBound = findLeftBound(imageWidth, cropWidth / 2, focus);
  if (leftBound + cropWidth > imageWidth) {
    return (imageWidth - cropWidth);
  } else {
    return leftBound;
  }
}
function findLeftBound(imageWidth, halfCropWidth, focusPoint) {
  if (focusPoint - halfCropWidth < 0) {
    return 0;
  } else if (focusPoint + halfCropWidth > imageWidth) {
    return imageWidth - halfCropWidth;
  } else {
    return focusPoint - halfCropWidth;
  }
}
const recValue = imageBounds()
//find rect ends
  if (typeof window === "undefined") {
    return (
      <figure styleName={wrapperStyleName} className={wrapperStyleName}>
        {imgURL ? (
          <LazyEagerImage
            styleName="image"
            className="image"
            src={`${imgURL}?rect=${recValue}&format=webp&${widthParameter}&dpr=2.0`}
            alt={captionAlt}
          />
        ) : (
          <LazyEagerImage
            styleName="image"
            className="image"
            src={`https://${cdnImage}/${imgS3keys}?rect=${recValue}&format=webp&${widthParameter}&dpr=2.0`}
          />
        )}
      </figure>
    );
  }
  return (
    <figure styleName={wrapperStyleName} className={wrapperStyleName}>
      {imgURL ? (
        <LazyEagerImage
          styleName="image"
          className="image"
          src={`${imgURL}?rect=${recValue}&format=webp&${widthParameter}&dpr=2.0`}
          alt={captionAlt}
        />
      ) : (
        <LazyEagerImage
          styleName="image"
          className="image"
          src={`https://${cdnImage}/${imgS3keys}?rect=${recValue}&format=webp&${widthParameter}&dpr=2.0`}
        />
      )}
    </figure>
  );
};
CardImage.propTypes = {
  story: object,
  aspectRatio: array,
  defaultWidth: number,
  imageType: string,
  widths: array,
  cdnImage:string
};
function mapStateToProps(state) {
  return ({
    defaultImage: get(state, ["qt", "config", "publisher-attributes", "defaultImageKey"], ""),
    cdnImage:get(state, ["qt","config","cdn-image"])
  });
}
export default connect(mapStateToProps, () => ({}))(CardImage);
